import COMPONENT_MAP from '../Repository/Components.js';

const UserDetailTravelTimeNewPopup=({popupCallBack,rowId,parent,userData,application})=>{

    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'TravelTime'}
                entityParams={['_context='+['parent_field_name='+parent.parent_field_name,'parent_field_value='+parent.parent_field_value,'parent_name='+parent.parent_name],'_lang='+application.globalData.lang]}
                file={'UserDetailTravelTimeNewPopup.js'}
                titleLabel={rowId?application?.getLocale("PageTabTravelTime"):application?.getLocale("PopupNewTravelTime")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
            />
        ):null; 
    };
    return (renderPageDetail());
}

export default UserDetailTravelTimeNewPopup;
